export const GAME_ID = 4169
export const PUBLIC_API_KEY = '5edb5f9a19de17fd7275b383850b78fb'
export const PRIMARY_COLOR = '#007bff'
export const DARK_COLOR = '#000000'
export const LIGHT_COLOR = '#f4f4f4'
export const DARK_MODE = false
export const TAG_FILTER = null
export const showLegal = true
export const hostURL = '*'
